export default {"src":"/_next/static/media/icon-mail.156bb14f.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};